import {
  PAYROLL_CARRYOVER_PERIOD,
  PAYROLL_CARRYOVER_LOADING,
  PAYROLL_CARRYOVER_ERROR,
} from '../types';
import api from '../../../utils/functions/api';

const BASE = `${process.env.REACT_APP_API_URL}/payroll-carryover`;

// รายการที่เกี่ยวกับงวดหนึ่ง — { incoming, outgoing }
export const payrollCarryoverByPeriod = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: PAYROLL_CARRYOVER_LOADING });
    const { data } = await api.get(BASE, { params });
    dispatch({ type: PAYROLL_CARRYOVER_PERIOD, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_CARRYOVER_ERROR });
    return { incoming: [], outgoing: [] };
  }
};

// ทุกรายการของพนักงาน 1 คน (ใช้ใน dialog) — ไม่แตะ redux
export const payrollCarryoverByEmployee = (employeeId) => async () => {
  const { data } = await api.get(`${BASE}/by-employee/${employeeId}`);
  return data;
};

export const payrollCarryoverCreate = (payload) => async (dispatch) => {
  try {
    const { data } = await api.post(BASE, payload);
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_CARRYOVER_ERROR });
    throw error;
  }
};

export const payrollCarryoverUpdate = (id, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(`${BASE}/${id}`, payload);
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_CARRYOVER_ERROR });
    throw error;
  }
};

export const payrollCarryoverCancel = (id) => async (dispatch) => {
  try {
    const { data } = await api.post(`${BASE}/${id}/cancel`);
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_CARRYOVER_ERROR });
    throw error;
  }
};

export const payrollCarryoverDelete = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`${BASE}/${id}`);
    return data;
  } catch (error) {
    dispatch({ type: PAYROLL_CARRYOVER_ERROR });
    throw error;
  }
};
